import * as z from "zod/v4";

export const appendSurchargeDisputeAttachments = {
  name: "appendSurchargeDisputeAttachments" as const,
  input: z.object({ disputeId: z.string(), attachments: z.array(z.string()) }),
  output: z.object({ success: z.boolean() }),
};
